// extracted by mini-css-extract-plugin
module.exports = {"PageHeading":"PageHeading_PageHeading__1VMag","HeadingTitle":"PageHeading_HeadingTitle__2qmvX","HeadingDesc":"PageHeading_HeadingDesc__Ss-7K"};